/**
 * Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchUserAccountAssetResponseItem } from './search-user-account-asset-response-item';


export interface SearchUserAccountsResponseItem { 
    id: string;
    name: string;
    amountInUsd: number;
    rewardType: string;
    assets: Array<SearchUserAccountAssetResponseItem>;
}

